/* ============================================================
   YoFresh bundle selector — variant-tile picker.

   Listens for tile clicks inside any [data-yf-bundle-card] group.
   On select:
     1. Updates visual state (.is-selected on chosen tile, off others)
     2. Updates the page's product-form hidden input[name="id"]
     3. Updates any [data-yf-cta-price] text nodes (hero + sticky bar)
     4. Dispatches `yf:bundle:change` custom event with full state

   Custom event detail:
     { variantId, price, priceFormatted, compare, compareFormatted,
       savingsFormatted, packLabel, variantTitle }
   ============================================================ */

(function () {
  'use strict';

  const CARD = '[data-yf-bundle-card]';
  const FORM_VARIANT_INPUT = 'input[name="id"].product-variant-id';
  const CTA_PRICE = '[data-yf-cta-price]';
  const CTA_COMPARE = '[data-yf-cta-compare]';
  const CTA_PACK = '[data-yf-cta-pack]';

  function readCardState(card) {
    return {
      variantId: card.dataset.variantId,
      price: parseInt(card.dataset.price, 10) || 0,
      priceFormatted: card.dataset.priceFormatted || '',
      compare: card.dataset.compare ? parseInt(card.dataset.compare, 10) : null,
      compareFormatted: card.dataset.compareFormatted || '',
      savingsFormatted: card.dataset.savingsFormatted || '',
      packLabel: card.dataset.packLabel || '',
      variantTitle: card.dataset.variantTitle || '',
    };
  }

  function updateSelectedClass(selectedCard) {
    const group = selectedCard.closest('.yf-bundle-selector');
    if (!group) return;
    group.querySelectorAll(CARD).forEach((c) => {
      const isSelected = c === selectedCard;
      c.classList.toggle('is-selected', isSelected);
      c.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });
  }

  function updateHiddenVariantInputs(variantId) {
    document.querySelectorAll(FORM_VARIANT_INPUT).forEach((input) => {
      if (input.value !== variantId) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function updateCtaDisplays(state) {
    document.querySelectorAll(CTA_PRICE).forEach((el) => {
      el.textContent = state.priceFormatted;
    });
    document.querySelectorAll(CTA_COMPARE).forEach((el) => {
      if (state.compareFormatted) {
        el.textContent = state.compareFormatted;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    document.querySelectorAll(CTA_PACK).forEach((el) => {
      el.textContent = state.packLabel || state.variantTitle;
    });
  }

  function select(card) {
    if (!card) return;
    updateSelectedClass(card);
    const state = readCardState(card);
    updateHiddenVariantInputs(state.variantId);
    updateCtaDisplays(state);
    document.dispatchEvent(
      new CustomEvent('yf:bundle:change', { detail: state, bubbles: true })
    );
    window.yofreshSelection = state;
  }

  function initGroup(group) {
    const cards = group.querySelectorAll(CARD);
    if (!cards.length) return;

    // Find default (preferred) or fall back to first card
    const defaultCard = group.querySelector(`${CARD}[data-default="true"]`) || cards[0];
    select(defaultCard);

    cards.forEach((card) => {
      card.addEventListener('click', () => select(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          select(card);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.yf-bundle-selector').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
